"use strict";

import module from "./module";
import "./module.spec";

export default module;
